import axios from 'axios';
import API from '../config/API';

export const usersService = {
    login,
    getUser,
    getAdminInvitedUsers,
    inviteUserBySms,
    getAllDishes,
    getUserDetail,
    getAdminDetail,
    editProfile,
    editUserProfile,
    changeUserStatus,
    deleteUser,

    forgot,
    changePassword,
    changeUserPassword,
    reset,
    sendDeleteAccountOTP,
    verifyOtp,
    deleteAccountWithOTP,
    getExam,
    deleteExam,

    getSetting,
    addSetting,
    editSetting,
}

const headersApplicationJson = {
    'Content-Type': 'application/json',
}
const headersMultipart = {
    "Content-type": "multipart/form-data",
}
const headersFormUrlEncoded = {
    'Content-Type': 'application/x-www-form-urlencoded',
}

function login(params) {
    return axios.post(API.LOGIN, params)
}

function forgot(params) {
    return axios.post(API.FORGOT, params)
}
function reset(params) {
    return axios.post(API.RESET, params)
}

function getExam(params) {
    return axios.get(`${API.GET_EXAM}${params?params:''}`);
}

function getUser(params) {
    return axios.get(`${API.GET_USER}/${params}`);
}

function getAdminInvitedUsers(params) {
    return axios.get(`${API.GET_ADMIN_INVITED_USERS}/${params}`);
}

function inviteUserBySms(params) {
    return axios.post(API.INVITE_USER_BY_SMS, params, {
        headers: headersApplicationJson
    });
}

function getCommunityPosts(params) {
    return axios.get(`${API.GET_COMMUNITY_POSTS}/${params}`);
}

function getUserDetail(params) {
    return axios.get(`${API.GET_USER_DETAIL}/${params}`);
}
function getAllDishes(params) {
    return axios.get(`${API.GET_USER_DISHES}/${params}`);
}
function getAdminDetail(params) {
    return axios.get(`${API.GET_ADMIN_DETAIL}`);
}

function changePassword(params) {
    return axios.post(API.CHANGE_PASSWORD, params);
}
function changeUserPassword(params) {
    return axios.post(API.CHANGE_USER_PASSWORD, params);
}

function editProfile(params) {
    return axios.post(API.EDIT_PROFILE, params);
}
function editUserProfile(params) {
    return axios.post(API.EDIT_USER_PROFILE, params);
}

function deleteExam(params) {
    return axios.delete(API.DELETE_EXAM, {data:params})
}

function changeUserStatus(params) {
    return axios.post(API.CHANGE_USER_STATUS, params)
}
function deleteUser(params){
    return axios.post(`${API.DELETE_USER}/${params}`);

}

function getSetting(params) {
    return axios.get(`${API.GET_SETTING}`);
}

function addSetting(params) {
    return axios.post(API.ADD_SETTING,params);
}
function editSetting(params) {
    return axios.post(API.EDIT_SETTING,params);
}

function sendDeleteAccountOTP(params) {
    const formData = new URLSearchParams();
    Object.keys(params).forEach(key => {
        formData.append(key, params[key]);
    });
    return axios.post(API.SEND_DELETE_ACCOUNT_OTP, formData, {
        headers: headersFormUrlEncoded
    });
}

function verifyOtp(params) {
    const formData = new URLSearchParams();
    Object.keys(params).forEach(key => {
        formData.append(key, params[key]);
    });
    return axios.post(API.VERIFY_OTP, formData, {
        headers: headersFormUrlEncoded
    });
}

function deleteAccountWithOTP(params) {
    // params should contain userId as query parameter and accessToken in headers
    const userId = params.userId;
    const accessToken = params.accessToken;
    const queryParams = userId ? `?userId=${userId}` : '';
    
    const headers = {
        ...headersApplicationJson,
        ...(accessToken && { accessToken: accessToken })
    };
    
    return axios.post(`${API.DELETE_ACCOUNT_WITH_OTP}${queryParams}`, null, {
        headers: headers
    });
}